/**
 * @file  list/style.ts
 * @description  list style and props
 *
 * @example <List color='true' width='true' />
 *
 * @author ogarcia (ozkary)
 *
 */
import styled from 'styled-components';
export { List, Typography, Image } from 'antd';

// link items
export interface Props {
  items: Anchor[];
  className?: string;
}

// link details
export interface Anchor {
  id: string;
  label: string;
  icon?: string;
  alt?: string;
  route?: string;
}

export const Icon = styled.a<Anchor>`
    rel="noopener noreferrer"
    key={id}
    aria-label={label}
    text-decoration=none    
    &:hover,
    &:active,
    &:focus {
        color: ${(props) => (props.color ? '#15418e' : '#fff')};
    }
`;
